<template>
  <div class="container">
    <div
      class="modal modal-xl fade"
      id="moduleBoardModal"
      tabindex="-1"
      aria-hidden="true"
      @click="controlStore.cancelModulePlacement()"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        @click.stop=""
      >
        <div class="modal-content">
          <div class="modal-header align-items-center">
            <h5 class="modal-title">Add Component</h5>

            
            <div class="ms-auto d-flex align-items-center">
              <button
                class="btn btn-sm btn-outline-primary me-2"
                type="button"
                @click.stop="onClickUpload"
              >
                Import JSON Component
              </button>
              <input
                ref="fileInput"
                type="file"
                accept="application/json"
                class="d-none"
                @change="onFileChange"
              />

              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="controlStore.cancelModulePlacement()"
              ></button>
            </div>
          </div>

          <div class="modal-body">
            <!-- built-in components -->
            <h6 class="text-muted mb-2">Built-in Components</h6>
            <div class="d-flex flex-wrap justify-content-evenly mb-3">
              <div
                v-for="(moduleCreator, index) in builtInModules"
                :key="'builtin-' + index"
                class="mx-2 my-2"
              >
                <ComponentBoardItem :moduleCreator="moduleCreator" />
              </div>
            </div>

            <!-- user JSON components -->
            <div v-if="userComponents.length > 0">
              <hr />
              <h6 class="text-muted mb-2">User Components (JSON)</h6>
              <div class="d-flex flex-wrap justify-content-evenly mb-3">
                <div
                  v-for="(moduleCreator, idx) in userComponents"
                  :key="'user-' + (moduleCreator.componentId || moduleCreator.componentJson?.id || moduleCreator.componentJson?.name || moduleCreator.moduleName || idx)"
                  class="mx-2 my-2"
                >
                  <ComponentBoardItem :moduleCreator="moduleCreator" />
                </div>
              </div>
            </div>

            <!-- custom presets -->
            <div v-if="customModules.length > 0">
              <hr />
              <h6 class="text-muted mb-2">My Templates</h6>
              <div class="d-flex flex-wrap justify-content-evenly">
                <div
                  v-for="(moduleCreator, idx) in customModules"
                  :key="'custom-' + idx"
                  class="mx-2 my-2"
                >
                  <ComponentBoardItem :moduleCreator="moduleCreator" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ComponentPropertyBoard />
  </div>
</template>

<script>
import { defineComponent, computed, ref } from "vue";
import { useControlStore } from "@/stores/control";
import { useMoudleStore } from "@/stores/module";
import ComponentBoardItem from "./ComponentBoardItem.vue";
import ComponentPropertyBoard from "./ComponentPropertyBoard.vue";

import { registerUserComponent } from "@/library/userModuleRegistry";


export default defineComponent({
  components: {
    ComponentBoardItem,
    ComponentPropertyBoard
  },
  setup() {
    const controlStore = useControlStore();
    const moduleStore = useMoudleStore();

    
    const fileInput = ref(null);

    const builtInModules = computed(() =>
      moduleStore.moduleFactory.filter(
        (c) => c && !c.isUserTemplate && !c.isUserComponent
      )
    );

    const customModules = computed(() =>
      moduleStore.moduleFactory.filter((c) => c && c.isUserTemplate)
    );

    const userComponents = computed(() =>
      moduleStore.moduleFactory.filter((c) => c && c.isUserComponent)
    );

    const onClickUpload = () => {
      if (fileInput.value) {
        fileInput.value.click();
      }
    };

    const onFileChange = (e) => {
      const target = e.target;
      const file = target.files && target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        try {
          const text = reader.result;
          const json = JSON.parse(text);

          
          if (json.formatVersion !== 1 || json.type !== "module-template") {
            window.alert("Invalid component JSON format.");
            return;
          }

          /** @type {UserComponentJson} */
          const component = json;

         
          registerUserComponent(component);

          window.alert("User component imported successfully!");
        } catch (err) {
          console.error(err);
          window.alert("Failed to import JSON: " + (err && err.message));
        } finally {
          
          target.value = "";
        }
      };
      reader.readAsText(file);
    };

    return {
      controlStore,
      builtInModules,
      customModules,
      userComponents,
      fileInput,
      onClickUpload,
      onFileChange
    };
  }
});
</script>

